export default __webpack_public_path__ + "static/media/Logo.8eb25d0a.svg";